<template>
  <analytics :poStillOpen="true"/>
</template>

<script>
export default {
  name: 'SupplierPoWoAnalyticsOpen',
  components: {
    'analytics': () => import(/* webpackChunkName: 'RFQSupplierPoWoAnalytics' */ '@/components/Shared/RFQSupplierPoWoAnalytics')
  }
}
</script>
